// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2gzcq","title":"Header_title__28kGL","side":"Header_side__2CYPu"};